import {React, useState, useEffect} from 'react';
import jawlogo from '../../Images/JE-logo.jpeg';
import cumminslogo from '../../Images/cummins.jpg';
import cummins1 from '../../Images/cummins-2.jpg';
import cummins2 from '../../Images/cummins-3.jpg';
import cummins3 from '../../Images/cummins-4.jpg';
import cummins4 from '../../Images/cummins-5.jpg';
import cummins6 from '../../Images/cummins-6.jpg';
import cummins7 from '../../Images/cummins-7.jpg';
// import cummins8 from '../../Images/cummins-8.jpg';
import cummins9 from '../../Images/cummins-9.jpg';
// import cummins10 from '../../Images/cummins-10.jpg';
import { FaPhoneAlt, FaEnvelope, FaFilePdf, FaTools, FaTruck, FaStar } from 'react-icons/fa';


// Placeholder images for the gallery and QR codes.
// Replace these with your actual image imports.
const galleryImages = [
 cummins1,
 cummins2,
 cummins3,
 cummins4,
 cummins7,
 cummins6,
];

const qrCodeHospet = 'https://via.placeholder.com/150';
const qrCodeChitradurga = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'

const JAW_CUMMINS = () => {

     // State for backend QR URLs for RANE sub-branches
    const [qrHospet, setQrHospet] = useState(null);
    const [qrChitradurga, setQrChitradurga] = useState(null);
  
    // Fetch QR for RANE Hospet and Chitradurga on mount
    useEffect(() => {
      async function fetchQRs() {
        try {
          const res1 = await fetch(`${API_BASE_URL}/branchqrcode/Cummins::Hospet`);
          if (res1.ok) {
            const data1 = await res1.json();
            setQrHospet(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
          } else {
            setQrHospet(null);
          }
  
          const res2 = await fetch(`${API_BASE_URL}/branchqrcode/Cummins::Chitradurga`);
          if (res2.ok) {
            const data2 = await res2.json();
            setQrChitradurga(data2.qrCodeImageURL.startsWith('http') ? data2.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data2.qrCodeImageURL.replace(/^\//, '')}`);
          } else {
            setQrChitradurga(null);
          }
        } catch {
          setQrHospet(null);
          setQrChitradurga(null);
        }
      }
      fetchQRs();
    }, []);
  

    const docs = [
  {
    name: "BREAK LINING",
    pdf: "/pdfs/break-lining.pdf"
  },
  {
    name: "CCC CATALOGUE",
    pdf: "/pdfs/ccc-catalogue.pdf"
  },
  {
    name: "CUMMINS ENGINE PARTS",
    pdf: "/pdfs/cummins-engine-parts.pdf"
  },
  {
    name: "BS4 SPECIFICATIONS",
    pdf: "/pdfs/bs4-specifications.pdf"
  },
  {
    name: "UJ CROSS GREASE",
    pdf: "/pdfs/uj-cross-grease.pdf"
  },
  {
    name: "UNIVERSAL JOINT",
    pdf: "/pdfs/universal-joint.pdf"
  }
];


  return (
    <>
  <section className="relative h-[390px] md:h-[370px] lg:h-[400px] w-full flex items-center justify-center overflow-hidden">
    {/* Background image */}
    <img
      src={cummins1}
      alt="Engine Workshop Background"
      className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
      style={{ zIndex: 1 }}
    />
    {/* Backdrop overlay for readability */}
    <div
      className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30"
      style={{ zIndex: 2 }}
    />

    {/* Content Row */}
    <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-6xl px-6 pt-4">
      {/* Logo */}
      <div className="flex flex-col items-center justify-center text-white w-full">
        <img
          src={jawlogo}
          alt="JAW Logo"
          className="w-20 h-20 object-cover drop-shadow-xl rounded-full mx-auto sm:mx-0"
        />
      </div>

      {/* Headings */}
      <h1 className="text-white text-3xl md:text-5xl font-bold tracking-tight leading-tight text-center drop-shadow-lg mt-4">
        JANATHA ENTERPRISES
      </h1>
      <div className="bg-red-500 p-2 text-center rounded-xl mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full">
        AUTHORIZED CUMMINS DISTRIBUTOR (CCC)
      </div>
      <div className="mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full text-center">
        Powering Performance with Precision
      </div>
    </div>
  </section>
      
      {/* Description Section */}
      <div className='mx-auto px-4 sm:px-8 md:px-12 lg:px-20 pt-4'>
    <div className='flex justify-center items-center gap-4'>
     <img src={cumminslogo} alt="rane-logo" className='h-16 md:h-24 content-center' />
        <div className='flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left'>
          <h2 className='text-2xl md:text-4xl  font-bold text-gray-900 font-sans mt-4 md:mt-0'>ABOUT JANATHA ENTERPRISES</h2>
        </div>
        </div>
        {/* <div className='border-b-4 border-red-500 pb-2 w-6'></div> */}
        <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700 '>
       Janatha Enterprises, a proud member of the Janatha Group, is an authorized distributor for Cummins India Ltd, one of the world’s most trusted names in automobile engine parts. With this strategic alliance, we are committed to delivering world-class genuine Cummins parts, and component care solutions across Vijayanagara, Bellary, Raichur, Koppal, Davanagere, and Shivamogga districts in Karnataka.
        </p>
      </div>

      {/* 3-Cards Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 py-12'>
        {/* Card 1 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          {/* <img src={cummins3} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' /> */}
         <div className=' flex items-center justify-center'>
           <FaTools className='w-28 h-28 sm:w-32 sm:h-32 text-red-500  bg-red-100 border-4 border-red-500 rounded-full p-6 '/>
         </div>
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Genuine Cummins Parts</h3>
          <p className='text-center text-sm md:text-base'>Authorized distributor with full warranty coverage.</p>
        </div>

        {/* Card 2 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          {/* <img src={cummins4} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' /> */}
        <div className=' flex items-center justify-center'>
           <FaTruck className='w-28 h-28 sm:w-32 sm:h-32 text-red-500  bg-red-100 border-4 border-red-500 rounded-full p-6 '/>
         </div>
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Engine Parts Sales</h3>
          <p className='text-center text-sm md:text-base'>Certified CCC parts and services</p>
        </div>

        {/* Card 3 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          {/* <img src={cummins6} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' /> */}
         <div className=' flex items-center justify-center'>
           <FaStar className='w-28 h-28 sm:w-32 sm:h-32 text-red-500  bg-red-100 border-4 border-red-500 rounded-full p-6 '/>
         </div>
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Sale of Component Care (CCC) Parts</h3>
          <p className='text-center text-sm md:text-base'>Serving 6 districts in Karnataka</p>
        </div>
      </div>

      {/* Commitment Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 p-8 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 shadow-2xl rounded-lg bg-gray-50'>
        <div className='space-y-4'>
          <h3 className='text-2xl md:text-3xl font-semibold text-gray-800'>Strengths That Set Us Apart</h3>
          <ul className='space-y-8 text-sm lg:text-xl md:text-base text-gray-600'>
            <li>Experienced Technical Workforce: Cummins-trained professionals with unmatched expertise.</li>
            <li>Inventory & Logistics Efficiency: Strong inventory of fast-moving parts.</li>
            <li>Customer-Centric Approach: Urgent request handling for maximum uptime.</li>
          </ul>
        </div>
        <div>
          <img src={cummins9} alt="rane-4" className='w-full h-48 md:h-72 lg:h-auto object-cover rounded-xl' />
        </div>
      </div>

      {/* PDF Section */}
      <div>
<section className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
    <h2 className="text-center text-3xl sm:text-4xl font-bold text-gray-900 mb-12">
      TECHNICAL RESOURCES &amp; DOCUMENTS
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {docs.map((doc, idx) => (
        <div
          key={doc.name}
          className="bg-white rounded-2xl shadow-md border-2 border-gray-300 flex flex-col items-center justify-center py-8 px-4 hover:shadow-xl transition cursor-pointer"
        >
          <a
            href={doc.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center w-full h-full gap-4"
          >
            <FaFilePdf className="text-red-600 text-6xl mb-2" />
            <span className="text-lg sm:text-xl font-bold text-gray-900 text-center mb-1">
              {doc.name}
            </span>
            <span className="text-sm font-semibold text-red-600">
              DOWNLOAD PDF <span className="inline-block ml-1">&rarr;</span>
            </span>
          </a>
        </div>
      ))}
    </div>
  </section>
      </div>
      
      {/* Gallery Section */}
      <div className='py-12 mx-4 sm:mx-8 md:mx-12 lg:mx-20 pt-12'>
        <h2 className='text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900'>Gallery</h2>
        <div className='grid grid-cols-2 md:grid-cols-3  gap-4'>
          {galleryImages.map((image, index) => (
            <div key={index} className='overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105'>
              <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-40 md:h-52 object-cover' />
            </div>
          ))}
        </div>
      </div>

      {/* Contact/Footer Section as per image */}
      <div className='py-12 bg-gray-900 text-white text-center px-4 sm:px-8 md:px-12 lg:px-20'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-2xl md:text-3xl lg:text-4xl font-bold pt-4 font-sans mb-2 text-red-400'>CUMMINS SUPPORT</h2>
          <p className='text-sm md:text-base text-gray-300 mb-8'>
        With Janatha Enterprises as your Cummins distributor — you get more than just parts
           <br />
           You get performance, productivity, and peace of mind.
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {/* Card 1: Contact Information */}
          <div className='bg-gray-800 p-6 rounded-lg shadow-lg'>
            <h3 className='text-xl font-bold mb-4'>CONTACT INFORMATION</h3>
            <div className='space-y-4 text-left'>
              <div>
                <p className='text-sm font-semibold mb-1 text-red-400'>Hospet</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-red-400' />
                  <span>6364836900</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-red-400' />
                  <span>jecumminshosapete@gmail.com</span>
                </div>
              </div>
              <hr className='border-gray-700' />
              <div>
                <p className='text-sm font-semibold mb-1 text-red-400'>Chitradurga</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-red-400' />
                  <span>6364836901</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-red-400' />
                  <span>janataenterprisesdrg@gmail.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Hospet Address */}
          <div className='bg-gradient-to-br from-red-900/50 to-red-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>HOSPET ADDRESS</h3>
            <p className='text-sm text-red-100 mb-4'>Scan for directions</p>
           <img
              src={qrHospet || qrCodeHospet}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-red-100'>Janatha Auto Works, #10, Janatha Complex, Hampi Road, Near Bala Talkies, Hospet-583201</p>
          </div>

          {/* Card 3: Chitradurga Address */}
          <div className='bg-gradient-to-br from-red-900/50 to-red-800/50  p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>CHITRADURGA ADDRESS</h3>
            <p className='text-sm text-red-100 mb-4'>Scan for directions</p>
           <img
              src={qrChitradurga || qrCodeChitradurga}
              alt="QR Code Chitradurga"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-red-100'>Chitradurga Hospet Road, Pillekerena Halli - 577501</p>
          </div>
        </div>
      </div>
      </>
  );
};

export default JAW_CUMMINS;